import { Injectable } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CameraService {

  constructor() { }

  checkCameraPermission(): Observable<PermissionState> {
    return navigator.permissions && navigator.permissions.query ? from(navigator.permissions.query({ name: 'camera' as PermissionName }))
        .pipe(
          map(permissionStatus => permissionStatus.state),
          catchError(error => {
            return of('prompt' as PermissionState);
          })
        ) : of('prompt' as PermissionState);
  }
}
